import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { OneTimePassword } from './OneTimePassword';
import { useAccountContext } from './AccountProvider';

interface DirectOTPAuthProps {
    setTokens: (tokens: any) => void;
}

export const DirectOTPAuth = ({ setTokens }: DirectOTPAuthProps) => {
    const { tempPhoneNumber, setTempPhoneNumber } = useAccountContext();
    const navigate = useNavigate();

    useEffect(() => {
        // If no phone number is stored, redirect to regular login
        if (!tempPhoneNumber) {
            navigate('/login');
            return;
        }
    }, [tempPhoneNumber, navigate]);

    const handleSetTokens = async (tokens: any) => {
        // Clear the temporary phone number once authentication is complete
        setTempPhoneNumber(null);

        // Set tokens (will be handled by parent DirectOTPContainer)
        setTokens(tokens);
    };

    const handleNavBack = () => {
        // Clear temp phone number and go back to login
        setTempPhoneNumber(null);
        navigate('/login');
    };

    if (!tempPhoneNumber) {
        return null; // Will redirect via useEffect
    }

    return (
        <OneTimePassword
            phone={tempPhoneNumber}
            setTokens={handleSetTokens}
            onNavBack={handleNavBack}
        />
    );
};
